import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import { withStyles } from '@material-ui/core/styles'
import LoadingComponent from '../loading/LoadingComponent'
import settings from '../../../libs/settings'
import { getUserInfo } from '../../../redux/selectors'

const styles = theme => ({
  content: {
    overflow: 'auto'
  },
  error: {
    padding: 0,
    margin: 12,
    display: settings.isProduction ? 'none' : 'block'
  },
  headline: {
    color: theme.palette.primary.main
  }
})

class ErrorComponent extends React.PureComponent {
  render () {
    const { classes, error, authorizing } = this.props

    return (
      <div className={classes.content}>
        {authorizing
          ? <LoadingComponent />
          : <Card className={classes.error}>
            <CardHeader
              classes={{title: classes.headline}}
              title={`${error.status ? error.status : 'Error'}: ${error.statusText ? error.statusText : error.message ? error.message : error.text ? error.text : 'Something went wrong. Please try again later.'}`}
            />
          </Card>
        }
      </div>
    )
  }
}

ErrorComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  error: PropTypes.object,
  authorizing: PropTypes.bool.isRequired
}

const mapStateToProps = state => ({ authorizing: getUserInfo(state).authorizing })

const ErrorConnect = connect(mapStateToProps, null)(ErrorComponent)

export default withStyles(styles)(ErrorConnect)
